import { PATH } from 'config'

const handleServerError = () => {
  window.location.assign(PATH.SERVER_ERROR)
}

export default handleServerError
